export const BASE_ENDPOINT = '/api/packages';

/**
 * API Endpoints used for fetching packages.
 */
export const ENDPOINTS = {
  FETCH_PACKAGES: BASE_ENDPOINT,
  PACKAGE_INDEX_REPORT: `${BASE_ENDPOINT}/report`,
};
